// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a4ccad2c","667":"48b9a60e"}[chunkId] + ".chunk.js";
};